import React, {useState} from 'react'
import './Pill.css'

const Pill = (props) => {

  const [disappear, setDisappear] = useState(false)

  const onClose = () => {
    setDisappear(true)
    setTimeout(()  => {
      props.onClose(props.name, props.value)
    }, 200)
  }

  const onEdit = () => {
    props.onEdit(props.name)
  }

  return (
    <span className={`pill ${disappear ? 'disappearing' : ''}`}>
      <span className='pill-body' onClick={onEdit}>
        {props.labelShow && (
            <span>{props.label}: </span>
          )
        }
        {props.translated ? 
            (
              <span>{props.display}</span>
            ) : (
              <span>{props.value}</span> 
            )
        }
      </span>
      <button className='close-pill' onClick={onClose}>X</button>
    </span>
  )

}

export default Pill



// WEBPACK FOOTER //
// ./src/components/Pill.js